import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.333 5.042v2.75q0 1.375-1.375 1.375h-2.75q-1.375 0-1.375-1.375v-2.75q0-1.375 1.375-1.375h2.75q1.374 0 1.375 1.375M7.79 3.667h-2.75q-1.375 0-1.375 1.375v2.75q0 1.375 1.375 1.375h2.75q1.375 0 1.375-1.375v-2.75q0-1.375-1.375-1.375m9.167 9.167h-2.75q-1.375 0-1.375 1.375v2.75q0 1.374 1.375 1.375h2.75q1.374 0 1.375-1.375v-2.75q0-1.375-1.375-1.375m-9.167 0h-2.75q-1.375 0-1.375 1.375v2.75q0 1.374 1.375 1.375h2.75q1.375 0 1.375-1.375v-2.75q0-1.375-1.375-1.375"
    }, null, -1)
  ])))
}
export default { render: render }